import React from 'react';

import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import moment from 'moment';

import ActiveDot from 'client/app/components/nav/breadcrumbs/components/ActiveDot';
import SubItemContainer from 'client/app/components/nav/breadcrumbs/components/SubItemContainer';
import {
  type VisEntityItem,
  NavNodeSubItem,
} from 'client/app/components/nav/breadcrumbs/types';

type Props = {
  isActive: boolean;
  item: NavNodeSubItem;
  icon: React.ReactElement;
  onClick: React.MouseEventHandler<HTMLElement>;
  onAuxClick: React.MouseEventHandler<HTMLElement>;
};

export default function VisEntityItem({
  item,
  isActive,
  icon,
  onClick,
  onAuxClick,
}: Props) {
  const visEntity = item as VisEntityItem;
  const timestamp = moment(visEntity.createdAt).format('YYYY-MM-DD HH:mm');

  return (
    <Container
      data-heap-tracking="breadcrumbs-vis-entity-item"
      onClick={onClick}
      onAuxClick={onAuxClick}
    >
      {icon}
      <Stack gap={1}>
        {isActive ? <ActiveDot /> : <span />}
        <Typography variant="subtitle2" color="textPrimary">
          {visEntity.name || 'N/A'}
        </Typography>
        <Typography variant="caption" color="textSecondary">
          {timestamp}
        </Typography>
      </Stack>
    </Container>
  );
}

const Container = styled(SubItemContainer)`
  grid-template-columns: 24px 1fr 30px;
`;
